// React
import { memo, useCallback } from "react";

// UI
import { NumberField } from "ui/components/TextField/NumberField";

// Lokalne komponente
import PricingStepIntro from "ui/modules/pricing/components/PricingStepIntro/PricingStepIntro";

// Tipovi i konstante
import { VALUE_KIND_UNIT } from "./consts";
import { PricingOtherValuesStepProps } from "./types";

/** Minimum, popust na godišnje plaćanje, probni period i maksimalne količine po vozilu. */
const PricingOtherValuesStep: React.FC<PricingOtherValuesStepProps> = (
  props: PricingOtherValuesStepProps
) => {
  const { formValues, setFormValues, items } = props;

  const handleValueChange = useCallback(
    (value: number | null, name?: string) => {
      if (!name) return;

      const code = name.replace("value-", "");

      setFormValues((previous) => ({
        ...previous,
        values: { ...previous.values, [code]: value },
      }));
    },
    [setFormValues]
  );

  return (
    <>
      <PricingStepIntro
        title="Ostale vrijednosti"
        description="Minimalni mjesečni iznos, popust na godišnje plaćanje, trajanje probnog perioda i maksimalne količine po vozilu. Ovo je zadnji korak, nakon njega se cjenik sprema."
      />

      <div className="p-4 w-full max-w-4xl mx-auto">
        <div className="flex flex-col gap-3">
          {items.map((item) => (
            <div key={item.code} className="flex flex-col md:flex-row gap-3 md:items-end">
              <div className="flex-1">
                <p className="text-sm text-slate-700">{item.name}</p>
                <p className="text-xs text-slate-400 font-mono">{item.code}</p>
              </div>

              {/*
                Jedinica stoji u polju kroz `groupAppend`, ne u labeli. Labela nosi značenje
                stupca, a „%" ili „dana" pripada uz sam broj.
              */}
              <div className="w-[200px]">
                <NumberField
                  name={`value-${item.code}`}
                  label="Vrijednost"
                  value={formValues.values[item.code] ?? 0}
                  onChange={handleValueChange}
                  groupAppend={VALUE_KIND_UNIT[item.valueKind]}
                  decimals={item.valueKind === "Money" || item.valueKind === "Percent" ? 4 : 0}
                  size="full"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default memo(PricingOtherValuesStep);
